import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { func, shape, string } from 'prop-types';
import { Form } from 'informed';
import { useSignIn } from '@magento/peregrine/lib/talons/SignIn/useSignIn';
import LoadingIndicator from '@magento/venia-ui/lib/components/LoadingIndicator';
import FormError from '@magento/venia-ui/lib/components/FormError';
import { isRequired, isEmailValid } from '@magento/venia-ui/lib/util/formValidators';
import Trigger from '@magento/venia-ui/lib/components/Trigger';
import TextInput from '@magento/venia-ui/lib/components/TextInput';
import combine from '@magento/venia-ui/lib/util/combineValidators';
import { useHistory } from 'react-router-dom';
import Field from '../../overrides/venia-ui/components/Field';
import defaultClasses from './signIn.module.css';
import { GET_CART_DETAILS_QUERY } from './signIn.gql';
import { useMergeCssClasses } from '../../Utils/utils';
import { Button } from '../';

var SignIn = function SignIn(props) {
  var classes = useMergeCssClasses(defaultClasses, props.classes);
  var setDefaultUsername = props.setDefaultUsername,
      showCreateAccount = props.showCreateAccount,
      showForgotPassword = props.showForgotPassword;
  var history = useHistory();

  var _useSignIn = useSignIn({
    getCartDetailsQuery: GET_CART_DETAILS_QUERY,
    setDefaultUsername: setDefaultUsername,
    showCreateAccount: showCreateAccount,
    showForgotPassword: showForgotPassword
  }),
      errors = _useSignIn.errors,
      handleSubmit = _useSignIn.handleSubmit,
      isBusy = _useSignIn.isBusy,
      setFormApi = _useSignIn.setFormApi;

  if (isBusy) {
    return React.createElement("div", {
      className: classes.modal_active
    }, React.createElement(LoadingIndicator, {
      classes: {
        root: 'h-full'
      }
    }, React.createElement(FormattedMessage, {
      id: 'signIn.loadingText',
      defaultMessage: 'Signing In'
    })));
  }

  return React.createElement("div", {
    className: classes.root
  }, React.createElement("h3", {
    className: "text-black mb-5 lg_mb-"
  }, React.createElement(FormattedMessage, {
    id: 'signIn.formText',
    defaultMessage: 'Login'
  })), React.createElement(Form, {
    getApi: setFormApi,
    className: classes.form,
    onSubmit: handleSubmit
  }, React.createElement("div", null, React.createElement("label", {
    className: "sr-only",
    htmlFor: "sign-in-email"
  }, "Email"), React.createElement(TextInput, {
    autoComplete: "email",
    field: "email",
    id: "sign-in-email",
    placeholder: "Email *",
    validate: combine([isRequired, isEmailValid]),
    validateOnBlur: true
  })), React.createElement("div", null, React.createElement(Field, {
    id: "password",
    label: "password"
  }, React.createElement(TextInput, {
    field: "password",
    autoComplete: "current-password",
    placeholder: "Password *",
    id: "password",
    type: "password",
    validateOnBlur: true,
    validate: isRequired
  })), React.createElement("p", {
    className: 'text-bronze text-xs'
  }, "Your password must contain a minimum of 8 characters, including at least 3 of the following: Lower Case, Upper Case, Number, Special Character.")), React.createElement("div", {
    className: classes.buttonsContainer
  }, React.createElement(Button, {
    priority: "low",
    type: "submit",
    "aria-label": "Login"
  }, React.createElement(FormattedMessage, {
    id: 'signIn.loginText',
    defaultMessage: 'Login'
  }))), React.createElement(Trigger, {
    classes: {
      root: 'flex justify-start text-bronze underline uppercase leading-2 font-semibold'
    },
    action: function action() {
      return history.push('/reset-password');
    },
    "aria-label": "Forgot Password?"
  }, React.createElement(FormattedMessage, {
    id: 'signIn.forgotPasswordText',
    defaultMessage: 'Forgot Password?'
  }))));
};

export default SignIn;
SignIn.propTypes = {
  classes: shape({
    buttonsContainer: string,
    form: string,
    forgotPasswordButton: string,
    forgotPasswordButtonContainer: string,
    root: string,
    title: string
  }),
  setDefaultUsername: func,
  showCreateAccount: func,
  showForgotPassword: func
};
SignIn.defaultProps = {
  setDefaultUsername: function setDefaultUsername() {},
  showCreateAccount: function showCreateAccount() {},
  showForgotPassword: function showForgotPassword() {}
};